import { render, staticRenderFns } from "./CooperationPanel.vue?vue&type=template&id=1fa0d7a8"
import script from "./CooperationPanel.vue?vue&type=script&lang=js"
export * from "./CooperationPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports